<template>
    <VueSlickCarousel v-bind="settings" class="co-crew-carousel relative z-10 mx-auto pb-6 md:pb-0 text-center">
        <slot></slot>

        <template #prevArrow>
            <div class="flex flex-col custom-left-arrow relative cursor-pointer lg:text-xl">
                View<br>more
                <img src="/assets/img/arrow-left.png" class="self-center mt-4" alt="Arrow left">
            </div>
        </template>
        <template #nextArrow>
            <div class="flex flex-col custom-right-arrow relative cursor-pointer lg:text-xl">
                View<br>more
                <img src="/assets/img/arrow-right.png" class="self-center mt-4" alt="Arrow right">
            </div>
        </template>
    </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
    components: {
        VueSlickCarousel,
    },

    data() {
        return {
            settings: {
                "speed": 500,
                "slidesToShow": 4,
                "slidesToScroll": 4,
                "initialSlide": 0,
                "responsive": [
                    {
                        "breakpoint": 1280,
                        "settings": {
                            "slidesToShow": 3,
                            "slidesToScroll": 3,
                        },
                    },
                    {
                        "breakpoint": 1024,
                        "settings": {
                            "slidesToShow": 2,
                            "slidesToScroll": 2,
                        },
                    },
                    {
                    "breakpoint": 640,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                        },
                    },
                ]
            }
        }
    }
}
</script>

<style lang="scss">
    .co-crew-carousel {
        @apply .flex .items-center #{!important};
    }

    .slick-list {
        width: 100% !important;
    }

    .bg-entry-box {
        @apply .bg-no-repeat;
        @apply .bg-center;
        @apply .max-w-full;

        > * {
            width: 203px;
            height: 195px;
            @apply .max-w-full;
            @apply .block;
            @apply .mx-auto;
        }
    }

    .entry-preview-image {
        width: 203px;
        height: 195px;
        @apply .object-cover;
        padding: 3.5%;
    }

    .bg-video-play-before--square {

        &:before {
            background-size: 80px;
        }

        &:hover {

            &:before {
                background-size: 100px;
            }
        }
    }
</style>
